import React from 'react';
import { motion } from 'framer-motion';
import { StarRating } from './StarRating';
import { useTranslation } from 'react-i18next';

export const ReviewCard = ({ review, index = 0 }) => {
  const { i18n } = useTranslation();
  
  const maskEmail = (email) => {
    const [name, domain] = email.split('@');
    return `${name[0]}***@${domain}`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const locale = i18n.language === 'lv' ? 'lv-LV' : 'ru-RU';
    return date.toLocaleDateString(locale, { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="bg-background p-6 rounded-sm border border-border"
      data-testid={`review-card-${review.id}`}
    >
      <div className="flex items-start justify-between mb-4">
        <div>
          <h4 className="font-body font-medium text-lg mb-1" data-testid="review-name">
            {review.name}
          </h4>
          <p className="text-sm text-muted-foreground" data-testid="review-date">
            {formatDate(review.created_at)}
          </p>
        </div>
        <StarRating rating={review.rating} />
      </div>
      
      <p className="font-body text-muted-foreground leading-relaxed" data-testid="review-comment">
        {review.comment}
      </p>
    </motion.div>
  );
};
